import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withContents } from "src/modules/content/operations";

import { withStateAndActionsForContent } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, contents, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"contents"}
            component={RenderSelect}
            placeholder={"Contents"}
            label={"Contents"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(contents?.map((content) => ({
                    id: content.id,
                    label: content.name || "",
                    value: JSON.stringify(content),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(
    withStateAndActionsForContent,
    withContents,
)(SubjectsField);
